<template>
  <v-menu bottom nudge-bottom="40" nudge-left="265" :close-on-content-click="false">
    <template #activator="{ on }">
      <v-icon :color="value" v-on="on"> mdi-circle </v-icon>
    </template>
    <v-color-picker
      v-model="computedValue"
      :hide-canvas="false"
      :hide-inputs="false"
      :hide-mode-switch="true"
      :show-swatches="false"
      mode="hexa"
    />
  </v-menu>
</template>
<script>
export default {
  props: {
    value: {
      type: String
    }
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(nV) {
        this.$emit('input', nV);
      }
    }
  }
};
</script>